import { render } from "./tashkilot-uchun.vue?vue&type=template&id=079d9694"
import script from "./tashkilot-uchun.vue?vue&type=script&lang=js"
export * from "./tashkilot-uchun.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__